// /src/UserList/UserList.jsx

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUsers } from "../api";
import { jwtDecode } from "jwt-decode";
import { filterUsersBySearch, getInitial, getAvatarColor } from "./userListUtils";

export default function UserList() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [myMobile, setMyMobile] = useState(null);
  const navigate = useNavigate();

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      navigate("/");
      return;
    }

    try {
      const decoded = jwtDecode(token);
      setMyMobile(decoded.mobile);
    } catch {
      navigate("/");
    }
  }, [token, navigate]);

  useEffect(() => {
    if (!myMobile) return;

    const fetchUsers = async () => {
      try {
        const res = await getUsers();
        const filtered = res.data.users.filter(
          (user) => user.mobile !== myMobile
        );
        setUsers(filtered);
        setFilteredUsers(filtered);
      } catch (err) {
        console.error("❌ Failed to fetch users:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();

    // Listen for profile updates to refresh user list
    const handleProfileUpdate = () => {
      fetchUsers();
    };

    window.addEventListener("profileUpdated", handleProfileUpdate);

    return () => {
      window.removeEventListener("profileUpdated", handleProfileUpdate);
    };
  }, [myMobile]);

  useEffect(() => {
    setFilteredUsers(filterUsersBySearch(users, searchTerm));
  }, [searchTerm, users]);

  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border text-primary" role="status" />
        <p className="mt-3">Loading users...</p>
      </div>
    );
  }

  return (
    <div className="container mt-4" style={{ maxWidth: 600 }}>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="fw-bold text-primary m-0">MINI-CHAT</h2>
        <a
          className="text-secondary link-dark fs-4 me-2"
          role="button"
          onClick={() => navigate("/settings")}
          title="Settings"
        >
          <i className="bi bi-gear"></i>
        </a>
      </div>

      {/* Search Input */}
      <input
        type="text"
        className="form-control mb-3"
        placeholder="Search users..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {/* User List */}
      <div className="list-group">
        {filteredUsers.map((user) => (
          <button
            key={user.mobile}
            className="list-group-item list-group-item-action d-flex align-items-center justify-content-between"
            onClick={() =>
              navigate(`/chat/${user.mobile}`, {
                state: { recipientName: user.name, recipientAvatar: user.avatar },
              })
            }
          >
            <div className="d-flex align-items-center">
              {user.avatar ? (
                <img
                  src={user.avatar}
                  alt="Avatar"
                  className="rounded-circle me-3"
                  style={{ width: 40, height: 40, objectFit: "cover", cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/profile/${user.mobile}`);
                  }}
                />
              ) : (
                <div
                  className="rounded-circle text-white d-flex justify-content-center align-items-center me-3"
                  style={{
                    width: 40,
                    height: 40,
                    fontSize: 16,
                    backgroundColor: getAvatarColor(user.name),
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/profile/${user.mobile}`);
                  }}
                >
                  {getInitial(user.name)}
                </div>
              )}
              <div>
                <div>{user.name}</div>
              </div>
            </div>

            {user.online && (
              <span
                className="ms-2"
                style={{
                  width: 10,
                  height: 10,
                  backgroundColor: "#28a745",
                  borderRadius: "50%",
                  display: "inline-block",
                }}
                title="Online"
              />
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
